import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { MetypeCommentingWidget } from "@metype/components";
import { generateHostStoryUrl } from "../utils/generate-story-url";
import get from "lodash/get";
import PropTypes from "prop-types";
import { getPageCommentsData } from "../utils/api";

import "./metype.m.css";

function MetypeCommentWrapperBase({ publisherAttributes = {}, story }) {
  const [commentsCount, setCommentsCount] = useState(0);
  const [showMetype, setShowMetype] = useState(false);

  useEffect(() => {
    getPageCommentsData(publisherAttributes["metypeAccountId"], story.url).then(data => {
      const count = get(data, ["page", "comments_count"], 0);
      setCommentsCount(count);
    });
  }, []);

  const toggleMetype = () => setShowMetype(!showMetype);

  return (
    <div>
      <div styleName="comments-count" onClick={toggleMetype}>
        {commentsCount || ""} Comment(s)
      </div>
      <div styleName={showMetype ? "" : "hide-comment"} className="metype-comments-container">
        <MetypeCommentingWidget
          host={publisherAttributes["metypeHost"]}
          accountId={publisherAttributes["metypeAccountId"]}
          pageURL={generateHostStoryUrl(story)}
          primaryColor={publisherAttributes["primaryColor"]}
          className={publisherAttributes["className"]}
        />
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"])
  };
}

export const MetypeCommentWrapper = connect(
  mapStateToProps,
  null
)(MetypeCommentWrapperBase);

MetypeCommentWrapperBase.propTypes = {
  publisherAttributes: PropTypes.object,
  metypeConfig: PropTypes.object,
  story: PropTypes.object
};
